import React, { useEffect, useState } from 'react';
import { adminService } from '../../services/api';

export default function SaIntegracoes() {
  const [settings, setSettings] = useState({});
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [asaasTest, setAsaasTest] = useState(null);
  const [testing, setTesting] = useState(false);

  const load = async () => { const r = await adminService.getSettings(); setSettings(r.data || {}); };
  useEffect(() => { load(); }, []);

  const testAsaas = async () => {
    setTesting(true); setAsaasTest(null);
    try {
      await adminService.updateSettings({ asaas_api_key: settings.asaas_api_key || '', asaas_env: settings.asaas_env || 'sandbox' });
      const r = await adminService.testAsaas();
      setAsaasTest(r.data);
    } catch (err) {
      setAsaasTest({ connected: false, error: err.response?.data?.error || err.message });
    } finally { setTesting(false); }
  };

  const set = (k, v) => { setSettings(s => ({ ...s, [k]: v })); setSaved(false); };

  const save = async () => {
    setLoading(true);
    try { await adminService.updateSettings(settings); setSaved(true); }
    catch (err) { alert('Erro: ' + (err.response?.data?.error || err.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Integrações</h1>
          <p style={styles.sub}>Configurações da plataforma (agência interativa)</p>
        </div>
        <button style={styles.btnPrimary} onClick={save} disabled={loading}>
          {loading ? 'Salvando...' : saved ? '✓ Salvo' : 'Salvar'}
        </button>
      </div>

      {/* ASAAS (assinaturas do SaaS) */}
      <div style={styles.panel}>
        <div style={styles.panelHead}>
          <span style={styles.panelIcon}>💰</span>
          <div>
            <div style={styles.panelTitle}>Asaas — Cobrança das assinaturas</div>
            <div style={styles.panelDesc}>Conta da agência que recebe o pagamento mensal dos planos dos tenants.</div>
          </div>
        </div>
        <Field label={`API Key do Asaas ${settings.asaas_api_key_set === '1' ? '(configurada ✓)' : ''}`}>
          <input style={styles.input} type="password"
            placeholder={settings.asaas_api_key_set === '1' ? '•••• já configurada (deixe vazio p/ manter)' : 'cole aqui a chave da sua conta Asaas'}
            value={settings.asaas_api_key || ''} onChange={e => set('asaas_api_key', e.target.value)} />
        </Field>
        <Field label="Ambiente">
          <select style={styles.input} value={settings.asaas_env || 'sandbox'} onChange={e => set('asaas_env', e.target.value)}>
            <option value="sandbox">Sandbox (testes)</option>
            <option value="production">Produção</option>
          </select>
        </Field>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button style={{ padding: '8px 14px', background: 'transparent', color: '#cbd5e1', border: '1px solid #374151', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }} onClick={testAsaas} disabled={testing}>
            {testing ? 'Testando…' : '🔌 Testar chave'}
          </button>
          {asaasTest && asaasTest.connected && (
            <span style={{ color: '#22c55e', fontWeight: 700, fontSize: 14 }}>● Conectado{asaasTest.account ? ` — ${asaasTest.account}` : ''}{asaasTest.test_mode ? ' (sandbox)' : ''}</span>
          )}
          {asaasTest && !asaasTest.connected && (
            <span style={{ color: '#ef4444', fontWeight: 700, fontSize: 14 }}>● Falhou — {asaasTest.error}</span>
          )}
        </div>

        <div style={{ borderTop: '1px solid #262636', margin: '16px 0 14px' }} />
        <div style={{ color: '#9ca3af', fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Webhook (atualiza o status do pagamento automaticamente)</div>
        <Field label="URL para colar no Asaas">
          <input style={styles.input} readOnly onFocus={e => e.target.select()}
            value="https://app.arenaxgamer.com/api/asaas/webhook" />
        </Field>
        <Field label={`Token de autenticação do webhook ${settings.asaas_webhook_token_set === '1' ? '(configurado ✓)' : ''}`}>
          <input style={styles.input} type="password"
            placeholder={settings.asaas_webhook_token_set === '1' ? '•••• já configurado (deixe vazio p/ manter)' : 'crie um token secreto (o mesmo que você põe no Asaas)'}
            value={settings.asaas_webhook_token || ''} onChange={e => set('asaas_webhook_token', e.target.value)} />
        </Field>
        <div style={{ color: '#6b7280', fontSize: 12 }}>
          No Asaas: <b>Configurações → Integrações → Webhooks</b> → adicione a URL acima, marque os eventos de <b>Pagamento</b> (recebido, confirmado, vencido) e informe este mesmo token. Pago → reativa; vencido → suspende a lan house.
        </div>
      </div>

      <div style={styles.panel}>
        <div style={styles.panelHead}><span style={styles.panelIcon}>🔁</span><div><div style={styles.panelTitle}>Mercado Pago — assinaturas dos jogadores</div><div style={styles.panelDesc}>Conta central da Arena X Gamer que recebe as mensalidades convertidas em horas.</div></div></div>
        <Field label={`Access Token ${settings.mp_access_token_set === '1' ? '(configurado ✓)' : ''}`}>
          <input style={styles.input} type="password" placeholder={settings.mp_access_token_set === '1'?'•••• já configurado':'APP_USR-...'} value={settings.mp_access_token||''} onChange={e=>set('mp_access_token',e.target.value)}/>
        </Field>
        <Field label="Webhook do Mercado Pago"><input style={styles.input} readOnly value="https://app.arenaxgamer.com/api/mercadopago/webhook" onFocus={e=>e.target.select()}/></Field>
        <div style={{color:'#6b7280',fontSize:12}}>Cadastre esta URL nos eventos de pagamentos da aplicação Mercado Pago da Arena X Gamer.</div>
      </div>

      {/* CLIENTE WINDOWS (atualização remota) */}
      <div style={styles.panel}>
        <div style={styles.panelHead}>
          <span style={styles.panelIcon}>🖥️</span>
          <div>
            <div style={styles.panelTitle}>Cliente Windows — atualização remota</div>
            <div style={styles.panelDesc}>Publique uma nova versão: os PCs baixam e se atualizam sozinhos no próximo boot.</div>
          </div>
        </div>
        <Field label="Versão publicada (ex: 1.1.0)">
          <input style={styles.input} value={settings.client_version || ''} onChange={e => set('client_version', e.target.value)} />
        </Field>
        <Field label="URL do instalador (.exe)">
          <input style={styles.input} placeholder="https://.../ArenaClient.exe" value={settings.client_download_url || ''} onChange={e => set('client_download_url', e.target.value)} />
        </Field>
        <Field label="Novidades da versão">
          <textarea style={{ ...styles.input, minHeight: 60, resize: 'vertical' }} value={settings.client_notes || ''} onChange={e => set('client_notes', e.target.value)} />
        </Field>
      </div>

      {/* SEO */}
      <div style={styles.panel}>
        <div style={styles.panelHead}>
          <span style={styles.panelIcon}>🔎</span>
          <div>
            <div style={styles.panelTitle}>SEO</div>
            <div style={styles.panelDesc}>Título e descrição usados na landing/página pública.</div>
          </div>
        </div>
        <Field label="Título (SEO)">
          <input style={styles.input} value={settings.seo_title || ''} onChange={e => set('seo_title', e.target.value)} />
        </Field>
        <Field label="Descrição (SEO)">
          <textarea style={{ ...styles.input, minHeight: 70, resize: 'vertical' }} value={settings.seo_description || ''} onChange={e => set('seo_description', e.target.value)} />
        </Field>
        <Field label="E-mail de suporte">
          <input style={styles.input} value={settings.support_email || ''} onChange={e => set('support_email', e.target.value)} />
        </Field>
      </div>

      <div style={styles.note}>
        🔒 As chaves ficam salvas no seu banco. As integrações de pagamento por lan house
        (Mercado Pago / Asaas dos clientes) são configuradas em cada empresa, na tela <b>Empresas</b>.
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return <div style={{ marginBottom: 14 }}><label style={styles.label}>{label}</label>{children}</div>;
}

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 20 },
  title: { color: '#fff', fontSize: 24, fontWeight: 700, margin: 0 },
  sub: { color: '#6b7280', fontSize: 14, margin: '4px 0 0' },
  btnPrimary: { padding: '10px 18px', background: 'var(--accent)', color: '#0a0a0f', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
  panel: { background: '#14141f', border: '1px solid #262636', borderRadius: 14, padding: 22, marginBottom: 18, maxWidth: 640 },
  panelHead: { display: 'flex', gap: 12, marginBottom: 18 },
  panelIcon: { fontSize: 26 },
  panelTitle: { color: '#fff', fontSize: 16, fontWeight: 700 },
  panelDesc: { color: '#6b7280', fontSize: 13, marginTop: 2 },
  label: { display: 'block', color: '#9ca3af', fontSize: 13, fontWeight: 500, marginBottom: 6 },
  input: { width: '100%', padding: '10px 12px', background: '#1c1c2b', border: '1px solid #34344e', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit' },
  note: { color: '#6b7280', fontSize: 13, background: '#14141f', border: '1px solid #262636', borderRadius: 10, padding: '14px 16px', maxWidth: 640 },
};
